import 'css-chunk:src/components/icons/SpinnerIcon.scss';export default {
  "SpinnerIcon": "_SpinnerIcon_k25lr_1",
  "spin": "_spin_k25lr_1"
};